<template>
    <div
        class="title-container"
        :class="[`title-${variant}`, { 'allow-document-selection': allowDocumentSelection }]"
    >
        <DsCheckbox
            v-if="allowDocumentSelection"
            v-model="isDocumentSelected"
            :name="documentConfig.title"
            :value="documentConfig.documentId"
        />
        <DocumentUploadItemTitle
            :documentTitle="documentConfig.title"
            :signersCount
        />
        <DsIconButton
            icon="fa-regular fa-trash-can"
            size="sm"
            tooltipText="Remove document"
            @click="fileDocumentStore.removeDocument(documentConfig.documentId)"
        />
    </div>
</template>

<script setup lang="ts">
import DsIconButton from '@/components/design-system/button/DsIconButton.vue';
import DsCheckbox from '@/components/design-system/form/input/DsCheckbox.vue';
import { isDocumentTemplateConfig } from '@/components/Views/Company/File/Documents/document-upload-utils';
import DocumentUploadItemTitle from '@/components/Views/Company/File/Documents/DocumentUploadItemTitle.vue';
import type { DocumentUploadConfig } from '@/components/Views/Company/File/file.types';
import { useFileDocumentStore } from '@/stores/file-document.store';
import { computed } from 'vue';

export interface DocumentUploadItemHeaderProps {
    allowDocumentSelection?: boolean;
    documentConfig: DocumentUploadConfig;
    variant: 'plain' | 'shaded';
}

const props = withDefaults(defineProps<DocumentUploadItemHeaderProps>(), {
    allowDocumentSelection: false,
});

const fileDocumentStore = useFileDocumentStore();

const signersCount = computed(() =>
    isDocumentTemplateConfig(props.documentConfig) ? props.documentConfig.template.signersCount : 0,
);

const isDocumentSelected = computed<DocumentUploadConfig['isSelected']>({
    get: () => props.documentConfig.isSelected,
    set: isSelected => fileDocumentStore.toggleDocumentSelected(props.documentConfig.documentId, isSelected),
});
</script>

<style scoped lang="scss">
.title-container {
    @apply grid items-center rounded-lg;

    &.allow-document-selection {
        @apply grid-cols-[auto_1fr_auto];
    }
    &:not(.allow-document-selection) {
        @apply grid-cols-[1fr_auto];
    }
}

.title-shaded {
    @apply border border-ds-primary-200 bg-ds-primary-50 p-4;
}
</style>
